import { createContext, useContext } from 'react';

const UserContext = createContext<any>(undefined);

export const useUserContext = () => useContext(UserContext);
export default UserContext;
